import { z } from 'zod'

/**
 * Termination declaration submitted through the public § 312k BGB form.
 *
 * Unauthenticated by statute: the cancellation button and its confirmation
 * page must be "ständig verfügbar sowie unmittelbar und leicht zugänglich",
 * which a login wall defeats.
 */
export const CancellationKind = z.enum(['ordinary', 'extraordinary'])
export type CancellationKind = z.infer<typeof CancellationKind>

export const CancellationEffective = z.enum(['next_possible', 'specific_date'])
export type CancellationEffective = z.infer<typeof CancellationEffective>

export const CancellationRequest = z.object({
  kind: CancellationKind,
  /** Required for extraordinary termination; never required for ordinary. */
  reason: z.string().optional(),
  email: z.string().email(),
  name: z.string().optional(),
  customer_number: z.string().optional(),
  /**
   * Free text by design — a consumer who cannot name their contract in our
   * internal terms must still be able to cancel it.
   */
  contract_reference: z.string().min(1),
  effective: CancellationEffective,
  effective_date: z.string().optional(),
  token: z.string().min(1)
})
export type CancellationRequest = z.infer<typeof CancellationRequest>

export const CancellationResponse = z.object({
  reference: z.string(),
  /** The declaration takes legal effect from this moment. */
  received_at: z.string(),
  identity_confirmation_required: z.boolean().optional()
})
export type CancellationResponse = z.infer<typeof CancellationResponse>
